<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title class="primary accent--text">
          <v-icon
            left
            color="accent"
          >
            shopping_basket
          </v-icon>
          Services Basket
        </v-card-title>

        <!-- Basket has Items -->
        <v-card-text v-if="basketHasItems()">
          <v-container>
            <v-row>
              <v-col cols="12">
                <service-select-dialog
                  :currency="currency"
                  :interval="interval"
                  :interval-count="intervalCount"
                  :added-ids="basketIds"
                  @action="onSelectPlan($event)"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      outlined
                      rounded
                      color="primary"
                      v-on="on"
                    >
                      <v-icon left>
                        add_shopping_cart
                      </v-icon>

                      Add another service
                    </v-btn>
                  </template>
                </service-select-dialog>
                <v-simple-table>
                  <table>
                    <thead>
                      <tr>
                        <th width="55%">
                          Pricing Plan
                        </th>
                        <th width="5%">
                          Quantity
                        </th>
                        <th
                          width="35%"
                          class="text-right"
                        >
                          Total
                        </th>
                        <th width="5%" />
                      </tr>
                    </thead>
                    <tbody>
                      <template
                        v-for="(item, itemIndex) in basket"
                      >
                        <tr :key="`row_${itemIndex}`">
                          <td>
                            {{ item.product.name }} - {{ item.nickname }} <br>
                            <span class="grey--text">{{ planTerms(item) }}</span>
                          </td>
                          <td>
                            <v-text-field
                              :disabled="item.deleted"
                              hide-details
                              outlined
                              dense
                              :value="item.quantity ? item.quantity : null"
                              @change="adjustQuantityByIndex($event, itemIndex)"
                            />
                          </td>
                          <td class="text-right">
                            <span v-if="item.deleted">
                              <v-btn
                                text
                                outlined
                                rounded
                                color="primary"
                                @click="restorePlanByIndex(itemIndex)"
                              >
                                <v-icon left>replay</v-icon> Restore
                              </v-btn>

                            </span>
                            <span v-if="!item.deleted">
                              {{ planTerms(item, item.quantity) }}
                            </span>
                          </td>
                          <td class="text-right">
                            <v-menu
                              v-if="!item.deleted"
                              left
                            >
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  icon
                                  v-on="on"
                                >
                                  <v-icon>more_vert</v-icon>
                                </v-btn>
                              </template>

                              <v-list
                                dense
                              >
                                <v-list-item @click="removePlanByIndex(itemIndex)">
                                  <v-list-item-title class="red--text">
                                    <v-icon
                                      color="red"
                                    >
                                      close
                                    </v-icon>

                                    Remove plan
                                  </v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                        </tr>
                      </template>

                      <!-- Coupon Row -->
                      <tr>
                        <td />
                        <td>
                          <coupon-select-dialog
                            v-if="!hasCoupon"
                            @action="onSelectCoupon"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                text
                                small
                                rounded
                                color="primary"
                                v-on="on"
                              >
                                Add Coupon
                              </v-btn>
                            </template>
                          </coupon-select-dialog>

                          <span
                            v-if="hasCoupon"
                          >
                            {{ coupon.name }} <span class="grey--text">({{ coupon.id }})</span>
                          </span>
                        </td>
                        <td class="text-right">
                          <span v-if="hasCoupon" />
                          {{ couponTerms() }}
                        </td>
                        <td class="text-right">
                          <v-menu
                            v-if="hasCoupon"
                            left
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                v-on="on"
                              >
                                <v-icon>more_vert</v-icon>
                              </v-btn>
                            </template>

                            <v-list>
                              <v-list-item @click="removeCoupon()">
                                <v-list-item-title class="red--text">
                                  <v-icon
                                    color="red"
                                  >
                                    close
                                  </v-icon>

                                  Remove Coupon
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </td>
                      </tr>

                      <!-- Tax Rates Row -->
                      <template v-if="hasTaxRates">
                        <tr v-for="(rate, index) in taxRates">
                          <td />
                          <td>
                            {{ rate.display_name }} - {{ rate.jurisdiction }}
                          </td>
                          <td class="text-right">
                            {{ rate.percentage }}%{{ rate.inclusive ? ' inclusive' : '' }}
                          </td>
                          <td class="text-right" />
                        </tr>
                      </template>

                      <tr>
                        <td />
                        <td>
                          <tax-rate-select-dialog
                            :init-selected="taxRateIds"
                            @action="onSelectTaxRates"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                small
                                text
                                rounded
                                color="primary"
                                v-on="on"
                              >
                                {{ hasTaxRates ? 'Update taxes' : 'Add Taxes' }}
                              </v-btn>
                            </template>
                          </tax-rate-select-dialog>
                        </td>
                        <td />
                        <td />
                      </tr>

                      <!-- Trial Period Row -->
                      <tr>
                        <td />
                        <td>
                          <service-trial-period-dialog
                            v-if="!hasTrial"
                            @action="onSetTrial"
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                small
                                text
                                rounded
                                color="primary"
                                v-on="on"
                              >
                                Add Trial
                              </v-btn>
                            </template>
                          </service-trial-period-dialog>
                        </td>
                        <td class="text-right">
                          <span
                            v-if="hasTrial"
                          >
                            <div class="caption grey--text">
                              Trial ends:
                            </div>
                            <div>
                              {{ formatDate(trialEnd, 'MMM Do, YYYY') }}
                            </div>
                          </span>
                        </td>
                        <td class="text-right">
                          <v-menu
                            v-if="hasTrial"
                            left
                          >
                            <template v-slot:activator="{ on }">
                              <v-btn
                                icon
                                v-on="on"
                              >
                                <v-icon>more_vert</v-icon>
                              </v-btn>
                            </template>

                            <v-list
                              dense
                            >
                              <service-trial-period-dialog
                                :init-unix="parseInt(trialEnd, 10)"
                                @action="onSetTrial"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-list-item
                                    v-on="on"
                                    @click.stop=""
                                  >
                                    <v-list-item-title>
                                      <v-icon left>
                                        edit
                                      </v-icon>

                                      Update Trial
                                    </v-list-item-title>
                                  </v-list-item>
                                </template>
                              </service-trial-period-dialog>


                              <v-list-item @click="removeTrial()">
                                <v-list-item-title class="red--text">
                                  <v-icon
                                    color="red"
                                    left
                                  >
                                    close
                                  </v-icon>

                                  Remove Trial
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <!-- Empty Basket -->
        <v-card-text
          v-if="!basketHasItems()"
          class="py-7"
        >
          <v-row>
            <v-col cols="12">
              <v-row
                align="center"
                justify="center"
              >
                <v-icon>shopping_basket</v-icon>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-row
                align="center"
                justify="center"
              >
                <span>Add a service to create a subscription</span>
              </v-row>
            </v-col>

            <v-col cols="12">
              <v-row
                align="center"
                justify="center"
              >
                <service-select-dialog
                  :currency="currency"
                  @action="onSelectPlan($event)"
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      rounded
                      outlined
                      color="primary"
                      v-on="on"
                    >
                      <v-icon left>
                        add
                      </v-icon>

                      Add a service
                    </v-btn>
                  </template>
                </service-select-dialog>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { get } from 'lodash'
import ServiceSelectDialog from "../Service/ServiceSelectDialog"
import { readablePlanTerms, readableCouponTerms } from "../../services/stripe.service"
import CouponSelectDialog from "../Coupon/CouponSelectDialog"
import ServiceTrialPeriodDialog from "../Service/ServiceTrialPeriodDialog"
import TaxRateSelectDialog from "../TaxRate/TaxRateSelectDialog"
import { unixToReadableDate } from "../../services/util.service"

export default {
  components: { TaxRateSelectDialog, ServiceTrialPeriodDialog, CouponSelectDialog, ServiceSelectDialog },
  props: {
    initSubscription: {
      type: Object,
      default: () => ({})
    },
    currency: {
      required: true,
      type: String,
    }
  },
  data() {
    return {
      isEditMode: false,
      isLoading: false,
      basket: [],
      coupon: null,
      taxRates: [],
      trialEnd: 0,
    }
  },
  computed: {
    taxRateIds() {
      return this.taxRates.map(r => r.id)
    },
    hasTaxRates() {
      return this.taxRates.length > 0
    },
    hasTrial() {
      return !!this.trialEnd
    },
    planTerms() {
      return (plan, quantity = 1) => readablePlanTerms(plan, quantity)
    },
    hasCoupon() {
      return !!this.coupon
    },
    interval() {
      const firstItem = this.basketHasItems()
        ? this.basket[ 0 ]
        : null

      return firstItem
        ? firstItem.interval
        : null
    },
    intervalCount() {
      const firstItem = this.basketHasItems()
        ? this.basket[ 0 ]
        : null

      return firstItem
        ? firstItem.interval_count
        : null
    },
    basketIds() {
      return this.basket.map(item => item.id)
    }
  },
  watch: {
    initSubscription() {
      this.isEditMode = true

      const subItems = get(this.initSubscription, 'items.data', [])

      /**
       * Subscription Items have a slightly different structure than Plans.
       * The Update methods requires this ID in addition to the plan ID
       */
      this.basket = subItems.map(i => {
        return {
          subscriptionItem: { ...i },
          ...i.plan,
          quantity: i.quantity
        }
      })

      this.coupon = get(this.initSubscription, 'discount.coupon', null)

      this.taxRates = get(this.initSubscription, 'default_tax_rates', [])

      this.trialEnd = get(this.initSubscription, 'trial_end', undefined)
    },
    basket() {
      this.$emit('change-items', this.basket)
    },
    coupon() {
      this.$emit('change-coupon', this.coupon)
    },
    taxRates() {
      this.$emit('change-taxes', this.taxRates)
    },
    trialEnd() {
      this.$emit('change-trial', this.trialEnd)
    }
  },
  methods: {
    isExistingPlan(planId) {
      const subItems = get(this.initSubscription, 'items.data', [])

      return subItems.findIndex(i => i.plan.id === planId) !== -1
    },
    onSelectPlan(plan) {
      if (plan) {
        this.addPlanToBasket(plan)
      }
    },
    restorePlanByIndex(index) {
      if (this.isEditMode) {
        const basketClone = [ ...this.basket ]
        basketClone[index].deleted = undefined
        this.basket = basketClone
      }
    },
    removePlanByIndex(index) {
      if (this.isEditMode) {
        const basketClone = [ ...this.basket ]
        const plan = basketClone[index]

        if (this.isExistingPlan(plan.id)) {
          basketClone[index].deleted = true
          this.basket = basketClone
          console.log('basket after remove', this.basket)
        } else {
          this.basket.splice(index, 1)
        }
      } else {
        this.basket.splice(index, 1)
      }
    },
    // maybe we only need this method, which should be defensive
    addPlanToBasket(plan) {
      const addedPlan = { ...plan }
      addedPlan.quantity = 1
      this.basket.push(addedPlan)
    },
    basketHasItems() {
      return Array.isArray((this.basket)) && this.basket.length > 0
    },
    adjustQuantityByIndex(something, index) {
      const basketClone = [ ...this.basket ]
      basketClone[ index ].quantity = parseInt(something, 10)
      this.basket = basketClone
    },
    onSelectCoupon(coupon) {
      if (coupon) {
        this.coupon = coupon
      }
    },
    removeCoupon() {
      this.coupon = null
    },
    couponTerms() {
      return this.coupon ? readableCouponTerms(this.coupon) : ''
    },
    onSetTrial(trialEnd) {
      this.trialEnd = trialEnd
    },
    removeTrial() {
      this.trialEnd = null
    },
    onSelectTaxRates(items) {
      this.taxRates = items
    },
    removeTaxRate(index) {
      this.taxRates.splice(index, 1)
    },
    formatDate(date, format) {
      return unixToReadableDate(date, format)
    }
  }
}
</script>
